'use strict';//Indicating browser should run only in java script mode

//var EMRRxInpatientViewModule = angular.module('EMR.RxInpatientViewModule', []);
;(function (){
var EnteredHxTabBarCodeRoutes = [

    
    {
        name: "Bar_Code_Entered_Hx_Tab_Main_View",
        //"url": "RxNewPrescriptionCurrentMeds/:patientChartInfo",
        templateUrl: "<div emr-bar-code-entered-hx-tab-main-view></div>",
        directivescontrollersFiles: "directiveFiles",
        RoutingNumber: 4051,
        files: [
            "AngularScripts/EnteredHxTabBarCode/Services/EnteredHxTabBarCodeService.js",
            "AngularScripts/EnteredHxTabBarCode/Directives/BarCodeEnteredHxTabMainViewDirective.js"
        ]
    },

    // {
    //     state: true,
    //     name: "ConsentToTakeMedicationWindowInfo",
    //     url: "ConsentToTakeMedicationWindowInfo/:patientChartInfo",
    //     templateUrl: "<div emr-current-medications-enter-bar-code-hx-tab-main-view></div>",
    //     //directivescontrollersFiles: "4206,4221,3070",
    //     RoutingNumber: 4052,
    //     files: [
    //         "AngularScripts/AdministerRx/Services/AdministerRxService.js",
    //         "AngularScripts/EnterBarCodeHxMainView/Directives/CurrentMedicationsEnterBarCodeHxTabMainViewDirective.js"
    //     ]
    // }, 

];


angular.module('EMR.EnteredHxTabBarCodeModule',[])
    .config(["$stateProvider", "EmrRouteProvider",
        function ($stateProvider, EmrRouteProvider) {
            EmrRouteProvider.registerStates(EnteredHxTabBarCodeRoutes, $stateProvider);
        }]);
    })();